<template>
  <div class="h5-favorites">
    <div class="h5-favorites__header">
      <p class="h5-favorites__title">
        My Favorites
      </p>
      <img
        @click="$router.back()"
        class="h5-favorites__close"
        src="@/assets/H5/offer/sourcing-close.svg"
        alt=""
      >
    </div>
    <div class="h5-favorites__content">
      <Tabs
        class="h5-favorites__tab"
        v-model:active="active"
        @change="onTabChange"
      >
        <Tab name="products">
          <template #title>
            Products
          </template>
        </Tab>
        <Tab name="factories">
          <template #title>
            Factories
          </template>
        </Tab>
      </Tabs>
      <RouterView />
    </div>
  </div>
</template>

<script setup>
import { Tab, Tabs } from '@/components/Tab'
import { RouterView } from 'vue-router'

const route = useRoute()
const router = useRouter()

const active = ref('products')

watch(() => route.name, (name) => {
  if (name === 'favoritesFactories') {
    active.value = 'factories'
  } else {
    active.value = 'products'
  }
}, {
  immediate: true
})

const onTabChange = (val) => {
  if (val === 'products') {
    router.replace('/favorites/products')
  } else if (val === 'factories') {
    router.replace('/favorites/factories')
  }
}
</script>

<style lang="less" scoped>
.h5-favorites {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  background-color: #141414;
  overflow: hidden;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    background-color: #FFFFFF;
    border-radius: 8px;
    height: 48px;
  }

  &__title {
    font-family: mon-700;
    font-size: 14px;
    line-height: 18px;
    color: #232323;
  }

  &__content {
    position: relative;
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 16px 12px 0;
    border-radius: 8px;
    background-color: #FFFFFF;
  }

  &__tab {
    padding-bottom: 8px;

    :deep(.tabs-nav) {
      border-bottom: none;
    }

    :deep(.tabs-nav__item) {
      padding-bottom: 7px;
    }

    :deep(.tabs-nav__line) {
      width: 24px;
      border-radius: 2px;
      background-color: #232323;
    }

    :deep(.tabs-content) {
      padding: 0;
    }
  }
}
</style>
